import React from 'react';
import {
    Box,
    Typography,
} from '@mui/material';

export default function LargeKeyValue(props) {
    const { label, value,  width } = props

    return (
        <div>
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: width }}>
                <Box >
                    <Typography sx={{ color: 'rgb(178, 235, 177)'}} variant="caption">
                        {label}
                    </Typography>
                    <Typography  sx={{ color: 'white'}} variant="h6">
                        {value}
                    </Typography>
                </Box>
            </div>
        </div>
    );
} 